import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader, Stat, EmptyState } from '@/components/ui-bits';
import { Building2, Users, Mail, MessageSquare } from 'lucide-react';

export default function SuperDashboardPage() {
  const [m, setM] = useState(null);
  const [tenants, setTenants] = useState([]);
  useEffect(() => {
    api.get('/superadmin/metrics').then((r) => setM(r.data));
    api.get('/superadmin/tenants').then((r) => setTenants(r.data.tenants));
  }, []);
  if (!m) return null;
  return (
    <div>
      <PageHeader title="Métricas globales" description="Vista global de la plataforma Zunoid CRM." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat label="Tenants" value={m.tenants_total} hint={`${m.tenants_active} activos`} />
        <Stat label="Usuarios" value={m.users_total} hint="Excluye SuperAdmin" />
        <Stat label="Leads totales" value={m.leads_total} />
        <Stat label="Mensajes" value={m.messages_total} />
      </div>
      <div className="surface p-5 mt-6">
        <h2 className="font-display font-semibold mb-3 flex items-center gap-2"><Building2 className="h-4 w-4" /> Top tenants</h2>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-muted-foreground border-b border-border"><th className="px-3 py-2">Tenant</th><th className="px-3 py-2">Estado</th><th className="px-3 py-2 text-right">Usuarios</th><th className="px-3 py-2 text-right">Leads</th><th className="px-3 py-2 text-right">Mensajes</th></tr></thead>
          <tbody>{tenants.slice(0, 20).map((t) => (
            <tr key={t.id} className="h-10 border-b border-border/70">
              <td className="px-3">{t.name}</td>
              <td className="px-3"><span className={`chip ${t.status === 'active' ? '' : 'text-[hsl(var(--danger))]'}`}>{t.status}</span></td>
              <td className="px-3 text-right tabular-nums">{t.users_count}</td>
              <td className="px-3 text-right tabular-nums">{t.leads_count}</td>
              <td className="px-3 text-right tabular-nums">{t.messages_count}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </div>
  );
}
